import React, { useContext, useEffect } from "react";
import AdminLayout from "../../components/layout/AdminLayout";
import * as FaIcons from "react-icons/fa";
import { Helmet } from "react-helmet";
import EmailFormList from "../../components/emailAdmin/EmailFormList";
import LoadingSpinner from "../../components/utilities/LoadingSpinner";
import llacFav from "../../img/LLAC-favicon.ico";
import AdminemailLogsContext from "../../context/adminemailLogs/adminemailLogsContext";

const EmailLoggerFormListPage = ({ history }) => {
   const adminemailLogsContext = useContext(AdminemailLogsContext);  
  const {
    getEntries,
    entries, 
    clearAgeFilter,
    clearSearchFilter,
    clearTableFilter,
    loading,
    clearNotinterestFilter,
    clearTransfer,
   
  } = adminemailLogsContext;



  
  useEffect(() => {
    getEntries();
   // gettransferRegistrations();
    return () => {
      clearAgeFilter();
      clearSearchFilter();
      clearTableFilter();
      clearNotinterestFilter();
      clearTransfer();
    };
  }, []);
  return (
    <AdminLayout>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Email Logger</title>
        <link rel="icon" type="image/x-icon" href={llacFav} />
      </Helmet>
      <section id="interest-form-list-page">
        <div className="container">
          <EmailFormList items={entries} history={history} />          
        </div>
      </section>
    </AdminLayout>
  );
};

export default EmailLoggerFormListPage;
